import * as yup from "yup";

export const validations = yup.object({
  gudang_name: yup.string().required("Wajib diisi"),
  id_user_pic: yup.array().min(1, "Wajib diisi").required("Wajib diisi"),
  lat: yup.mixed().required("Wajib diisi"),
  long: yup.mixed().required("Wajib diisi"),
});
